module.exports = __webpack_public_path__ + "static/media/client-mondelez.faca9747.png";